import createBrowserHistory from 'history/createBrowserHistory';

export const history = createBrowserHistory();

export const redirect = path => history.push(path);

export default history;
